module.exports = __webpack_public_path__ + "static/media/ba.0dd4db87.svg";